import { defineMessages } from 'react-intl';

export default defineMessages({
  pickupInformation: {
    description: 'orderDrawer.pickupInformation.pickupInformation',
    defaultMessage: 'Pickup Information',
    id: 'mRM+Oz',
  },
});
